import { clsx } from 'clsx';
import { BUTTON_VARIANT } from 'constants/interfaces';

import DotsLoader from '../DotsLoader/DotsLoader';

import type IButton from './interfaces/IButton';

import styles from './sass/Button.module.scss';

function Button({
  title,
  onClick,
  className,
  startIcon,
  endIcon,
  disabled,
  variant = BUTTON_VARIANT.primary,
  buttonStyles,
  isLoading,
  loadingIndicator,
  type = 'button',
  form,
  labelKey,
}: IButton) {
  const classes = clsx(styles.button, styles[variant], className);

  return (
    <button
      className={classes}
      onClick={onClick}
      disabled={disabled || isLoading}
      form={form}
      type={type === 'submit' ? 'submit' : 'button'}
      style={buttonStyles}
      data-i18n-key={labelKey}
    >
      {isLoading ? (loadingIndicator || <DotsLoader />) : (
        <>
          {startIcon ? <span>{startIcon}</span> : null}
          <span>{title}</span>
          {endIcon ? <span>{endIcon}</span> : null}
        </>
      )}
    </button>
  );
}

export default Button;
